import { Reveal } from "./Reveal";
import SectionHead from "./SectionHead";

const PRICES = [
  ["Billard · Mo – Do", "12 € / Std."],
  ["Billard · Fr – Sa", "14 € / Std."],
  ["Steel Dart", "6 € / Std."],
  ["Tischkicker", "2 € / 15 Min."],
];

export const HOURS = [
  ["Montag", "geschlossen"],
  ["Dienstag", "16:00 – 00:00 Uhr"],
  ["Mittwoch", "16:00 – 00:00 Uhr"],
  ["Donnerstag", "16:00 – 00:00 Uhr"],
  ["Freitag", "16:00 – 01:00 Uhr"],
  ["Samstag", "16:00 – 01:00 Uhr"],
  ["Sonntag", "15:00 – 22:00 Uhr"],
];

const MenuRow = ({ name, value, muted = false, testid }) => (
  <div className="flex items-end gap-4 py-3" data-testid={testid}>
    <span className="text-[#f4ecdd]">{name}</span>
    <span className="mb-1.5 flex-1 border-b border-dotted border-[#c9bda9]/30" />
    <span className={`whitespace-nowrap font-display text-lg ${muted ? "italic text-[#c9bda9]/70" : "text-[#e3c988]"}`}>
      {value}
    </span>
  </div>
);

export default function Preise() {
  return (
    <section id="preise" data-testid="preise-section" className="bg-[#1c1512] px-6 py-24 md:px-10 md:py-36">
      <div className="mx-auto max-w-6xl">
        <SectionHead chapter="04" eyebrow="Preise & Öffnungszeiten" title="Die Karte." />
        <Reveal className="mt-16">
          <div
            data-testid="happy-hour-banner"
            className="relative overflow-hidden border border-[#c9a24a]/40 bg-[#5c1a1f] px-6 py-12 text-center md:py-16"
          >
            <div className="pointer-events-none absolute inset-2 border border-[#c9a24a]/25" />
            <div className="pointer-events-none absolute inset-3 border border-[#c9a24a]/15" />
            <p className="text-xs uppercase tracking-[0.3em] text-[#e3c988]" data-testid="happy-hour-time">
              Jeden Tag · 16 – 18 Uhr
            </p>
            <p className="mt-4 font-display text-5xl font-light text-[#f4ecdd] md:text-7xl">
              Happy <span className="italic text-[#e3c988]">Hour</span>
            </p>
            <p className="mt-6 text-base text-[#f4ecdd]/90 md:text-lg" data-testid="happy-hour-deal">
              Billard statt <s className="text-[#c9bda9]/70">12 / 14 €</s> nur{" "}
              <span className="font-display text-3xl text-[#e3c988] md:text-4xl">10 € / Std.</span>
            </p>
            <p className="mt-3 text-base text-[#f4ecdd]/90 md:text-lg" data-testid="happy-hour-deal-dart">
              Dart statt <s className="text-[#c9bda9]/70">6 €</s> nur{" "}
              <span className="font-display text-3xl text-[#e3c988] md:text-4xl">5 € / Std.</span>
            </p>
          </div>
        </Reveal>
        <div className="mt-8 grid gap-8 lg:grid-cols-2">
          <Reveal className="order-2" delay={0.12}>
            <div data-testid="price-card" className="relative border border-[#c9a24a]/25 p-8 md:p-12">
              <div className="pointer-events-none absolute inset-2 border border-[#c9a24a]/15" />
              <p className="text-xs uppercase tracking-[0.22em] text-[#c9a24a]">Preise</p>
              <div className="mt-6">
                {PRICES.map(([name, value]) => (
                  <MenuRow key={name} name={name} value={value} testid={`price-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} />
                ))}
              </div>
              <p className="mt-6 text-sm text-[#c9bda9]/70">Queue, Kreide & Bälle inklusive.</p>
            </div>
          </Reveal>
          <Reveal className="order-1">
            <div data-testid="hours-card" className="relative border border-[#c9a24a]/25 p-8 md:p-12">
              <div className="pointer-events-none absolute inset-2 border border-[#c9a24a]/15" />
              <p className="text-xs uppercase tracking-[0.22em] text-[#c9a24a]">Öffnungszeiten</p>
              <div className="mt-6">
                {HOURS.map(([name, value]) => (
                  <MenuRow key={name} name={name} value={value} muted={value === "geschlossen"} testid={`hours-${name.toLowerCase()}`} />
                ))}
              </div>
              <p className="mt-6 text-sm text-[#c9bda9]/70" data-testid="reservation-note">
                Anfragen & Reservierungen gerne per Mail an{" "}
                <a
                  href="mailto:vintagebillard@gmail.com"
                  data-testid="mail-link-preise"
                  className="text-[#e3c988] underline decoration-[#c9a24a]/40 underline-offset-4 transition-colors duration-300 hover:text-[#c9a24a]"
                >
                  vintagebillard@gmail.com
                </a>{" "}
                oder telefonisch unter{" "}
                <a
                  href="tel:+4917632526128"
                  data-testid="phone-link-preise"
                  className="whitespace-nowrap text-[#e3c988] underline decoration-[#c9a24a]/40 underline-offset-4 transition-colors duration-300 hover:text-[#c9a24a]"
                >
                  0176 32526128
                </a>{" "}
                — besonders am Wochenende: einfach mal anrufen.
              </p>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="mt-16">
          <div id="speisekarte" className="mx-auto max-w-2xl">
            <p className="mb-6 text-center text-xs uppercase tracking-[0.22em] text-[#c9a24a]">
              Unsere Karte — Spiel, Spaß & Genuss
            </p>
            <a
              href="/images/speisekarte.jpg"
              target="_blank"
              rel="noreferrer"
              data-testid="speisekarte-link"
              className="block border border-[#c9a24a]/25 p-3 transition-colors duration-500 hover:border-[#c9a24a]/60"
            >
              <img
                src="/images/speisekarte.jpg"
                alt="Speisekarte von Vintage Billard — Getränke, Snacks und Sandwiches"
                data-testid="speisekarte-image"
                className="w-full"
                loading="lazy"
              />
            </a>
            <p className="mt-4 text-center text-sm text-[#c9bda9]/70">
              Zum Vergrößern einfach auf die Karte tippen.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
